export enum EDomainScopedRoles {
  VISIT = 'VISIT',
  PATIENT = 'PATIENT',
  COMMUNITY = 'COMMUNITY',
  ORGANIZATION = 'ORGANIZATION',
  PRACTICE = 'PRACTICE',
}
